if (!customElements.get('ggp-variant-specs')) {
  customElements.define(
    'ggp-variant-specs',
    class GgpVariantSpecs extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.section;
        this.blocks = Array.from(this.querySelectorAll('[data-ggp-spec]'));

        // Hook into Dawn's variant-change pub/sub when available.
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (payload) => {
            const detail = payload && payload.data;
            if (!detail) return;
            if (this.sectionId && detail.sectionId && String(detail.sectionId) !== String(this.sectionId)) {
              return;
            }
            this.show(detail.variant ? detail.variant.id : null);
          });
        }
      }

      disconnectedCallback() {
        if (this.unsubscribe) this.unsubscribe();
      }

      show(variantId) {
        let target = variantId
          ? this.querySelector('[data-ggp-spec][data-variant="' + variantId + '"]')
          : null;
        if (!target) {
          target = this.querySelector('[data-ggp-spec][data-variant="default"]');
        }
        this.blocks.forEach((block) => {
          block.hidden = block !== target;
        });
      }
    }
  );
}
